/**
 * @generated SignedSource<<af1622d616874aa73f384174551a815b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentNewsletterArticleArticle$data = {
  readonly entityId: string;
  readonly relatedLinks: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly " $fragmentType": "contentNewsletterArticleArticle";
};
export type contentNewsletterArticleArticle$key = {
  readonly " $data"?: contentNewsletterArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentNewsletterArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentNewsletterArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "relatedLinks",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a016ffb897fd7166b7fa942d3191e094";

export default node;
